<!--====== Banner Start ======-->
<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center h-100 w-100">
                <img src="../../../assets/images/banners/carporatebannarimages.png" alt="corporate giving"
                    class="img img-responsive w-100 h-100 d-none d-md-block">
                <img src="../../../assets/images/banners/carporate_mobilebannar.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="corporate giving mobile banner" />
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-md-4 col-sm-12">
                            <div class="banner-section">
                                <div class="align-items-center banner-content-title global_title global_banner_title"
                                    role="heading" aria-level="1">
                                    <span>Corporate Giving </span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                    <span>Learn how we're working together around the globe to engineer a better
                                        world.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== Banner End ======-->
<!--====== Carporate Giving creating fairer Start ======-->
<div class="carporate_belivesection">
    <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-lg-4">
            <img src="../../../assets/images/carporategiving_images/webeliveimage.png"
             alt="webeliveimage"
             class="img-responsive carporate_mediacontent"
             loading="lazy">
        </div>
        <div class="col-lg-5"role="paragraph">
            <div class="carporate_mainsection carporate_mediacontent ">
                <div class="global_section_header carporate_blodcontent">We Believe in</div>
                <div class="global_section_header carporate_blodcontent">Creating a Fairer and</div>
                <div class="global_section_header carporate_blodcontent">Equitable World for all</div>
                <div class="global_section_content pt-5">
                    We pride ourselves on giving back to the community and supporting local businesses and
                    organizations.
                    We encourage our employees to get involved with community volunteer work and match employee
                    donations/contributions
                    for causes they are passionate about. The following is a short list of ways we get involved when it
                    comes to corporate giving...
                    because we care !
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>
<!--====== Carporate giving carousel Start ======-->
<div class="casestudy_carouselbgcolor">
    <div class="carousel-sliders-wrapper pt-5">
        <div class="global_section_header text-center pt-5 carporate_blodcontent" role="heading" aria-level="1">Our impact initiatives
        </div>
        <div class="global_section_content text-center">Learn how we’re working together around the globe to engineer a
            better world. </div>
        <div class="container-fluid pr-0">
            <div class="row">
                <div class="col-lg-12">
                    <swiper-container class="carousel-slider__container mt-3"
                     [autoplay]="{ delay: 3000 }"
                      [loop]="true"
                        [pagination]="{ el: '.swiper-pagination', clickable: true }" 
                        [breakpoints]="swiperBreakpoints"
                        role="region"
                        aria-label="Corporate Giving Carousel">
                        <swiper-slide class="py-5 px-2">
                            <div class="carousel-slider wow move-up">
                                <div class="carousel-slider__image">
                                    <img src="../../../assets/images/carporategiving_images/communicaty.png"
                                        alt="community" class="carporategiving_carouselimages carporate_mediacontent">
                                </div>
                                <div class="carousel-slider__content text-center">
                                    <div class="headeing text-black casestudy_carouselcontent global_sub_title carporate_blodcontent"
                                        role="heading" aria-level="1">Our impact initiatives</div>
                                    <div class=" global_section_content" role="heading" aria-level="1">
                                        Learn how we’re working together around the globe to engineer a better world.
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="py-5 px-2">
                            <div class="carousel-slider wow move-up">
                                <div class="carousel-slider__image">
                                    <img src="../../../assets/images/carporategiving_images/event.png" alt="carporategiving images"
                                        class="carporategiving_carouselimages carporate_mediacontent">
                                </div>
                                <div class="carousel-slider__content text-center">
                                    <div class="headeing casestudy_carouselcontent global_sub_title text-black carporate_blodcontent"
                                        role="heading" aria-level="1">Event Sponsorships </div>
                                    <div class="text global_section_content" role="heading" aria-level="1">
                                        We take pride in sponsoring Sponsorships for uplifting the cause of communities.
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="py-5 px-2">
                            <div class="carousel-slider wow move-up">
                                <div class="carousel-slider__image">
                                    <img src="../../../assets/images/carporategiving_images/organization.png"
                                        alt="communication"
                                        class="carporategiving_carouselimages carporate_mediacontent">
                                </div>
                                <div class="carousel-slider__content text-center">
                                    <div class="headeing casestudy_carouselcontent global_sub_title text-black carporate_blodcontent"
                                        role="heading" aria-level="1">Local Community Organization Sponsorships</div>
                                    <div class="text global_section_content" role="heading" aria-level="1">
                                        We believe that charity begins from home and so we start with local communities.
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="py-5 px-2">
                            <div class="carousel-slider wow move-up">
                                <div class="carousel-slider__image">
                                    <img src="../../../assets/images/carporategiving_images/breastcancer.png"
                                        alt="Breast Cancer Fundraiser Support Image"
                                        class="carporategiving_carouselimages carporate_mediacontent">
                                </div>
                                <div class="carousel-slider__content text-center">
                                    <div class="headeing casestudy_carouselcontent global_sub_title text-black carporate_blodcontent"
                                        role="heading" aria-level="1">Breast Cancer Fundraisers</div>
                                    <div class="text" role="heading" aria-level="1">
                                        We support fighters. We're a proud women-owned organization who strive to build
                                        a better world.
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper-container>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== Carporate giving carousel End ======-->
<!--====== Carporate Giving Sustainable  Start ======-->
<div class="carporate_sustainablesection">
    <div class="global_section_header text-center carporate_blodcontent" role="heading" aria-level="1">Sustainable in heart & soul
    </div>
    <img src="../../../assets/images/carporategiving_images/suistanable.png" alt="heart soul"
        class="Sustainableimage pt-5">
    <div class="row">
        <div class="container">
            <div class="col-lg-12">
                <div class="global_section_content text-center pt-5" role="heading" aria-level="1">
                    We must as citizens and as organizations undertake rapid, far-reaching, and unprecedented changes in
                    all
                    aspects of society and we believe it is our corporate responsibility.
                    We believe that the power to generate positive change in the world is in each and every person if we
                    believe in it so.
                    We want to take charge and push the boundaries in building a more responsible society through
                    collaboration and innovation.
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== Carporate Giving Sustainable  Start ======-->
<!--===========  Carporate giving Join US  Start =============-->
<div class="carporate_joinusmainsection">
<div class="feature-images-wrapper section-space--ptb_50">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title-wrap text-center carporate_joinussection">
                    <div class="section-sub-title mb-20 global_section_header carporate_blodcontent" role="heading" aria-level="1">Join Us and find your purpose! </div>
                    <div class="heading global_section_content"  role="heading" aria-level="1">If you had the chance, how would you make a difference? At Maganti IT, 
                        we do much more than just’ business. Learn more about our culture and discover our people and their stories. 
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="feature-images__one">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-images style-01">
                                <div class="image-box-wrap">
                                    <div class="box-image">
                                    <img src="../../../assets/images/carporategiving_images/mitimage.png"
                                        alt="explore maganti" class="img-fluid">
                                    </div>
                                    <div class="content">
                                        <div class="global_sub_title journey-heading carporate_blodcontent text-black" role="heading" aria-level="1">Explore Maganti IT</div>
                                        <div class=" global_section_content text"  role="heading" aria-level="1">Discover our portfolio of services to
                                            get accelerate growth for your business.
                                        </div>
                                        <div class="circle-arrow">
                                            <div class="middle-dot"></div>
                                            <div class="middle-dot dot-2"></div>
                                            <a routerlink="case-studies" href="/case-studies" aria-label="case-studies">
                                                <i  style ="color: #ffff;"class="fa fa-long-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-images style-01">
                                <div class="image-box-wrap">
                                    <div class="box-image">
                                    <img src="../../../assets/images/carporategiving_images/connect.png"
                                        alt="connect" class="img-fluid">
                                    </div>
                                    <div class="content">
                                        <div class="global_sub_title carporate_blodcontent  journey-heading text-black"  role="heading" aria-level="1">Connect with us</div>
                                        <div class="global_section_content text"  role="heading" aria-level="1">Tell us what you’re looking for and
                                            we’ll get you connected to the right people.
                                        </div>
                                        <div class="circle-arrow">
                                            <div class="middle-dot"></div>
                                            <div class="middle-dot dot-2"></div>
                                            <a href="/contact" aria-label="View Contact Page">
                                                <i  style ="color: #ffff;"class="fa fa-long-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-images style-01">
                                <div class="image-box-wrap">
                                    <div class="box-image">
                                    <img src="../../../assets/images/carporategiving_images/carrers.png"
                                        alt="careers" class="img-fluid">
                                    </div>
                                    <div class="content">
                                        <div class="global_sub_title carporate_blodcontent journey-heading text-black"  role="heading" aria-level="1">Careers</div>
                                        <div class="global_section_content text">
                                            Your career is about what you want to be and who you want to be. Explore.
                                        </div>
                                        <div class="circle-arrow">
                                            <div class="middle-dot"></div>
                                            <div class="middle-dot dot-2"></div>
                                            <a href="/careers" aria-label="View Careers Page" target="_blank" rel="noopener noreferrer">
                                                <i style ="color: #ffff;" class="fa fa-long-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section-under-heading text-center section-space--mt_80"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--===========  Carporate giving Join US  End =============-->